import {
  Paper as MUIPaper,
  styled,
  type PaperOwnProps,
  type SxProps,
  type Theme,
} from "@mui/material";

type PaperProps = {
  children?: React.ReactNode;
  variant?: PaperOwnProps["variant"];
  sx?: SxProps<Theme>;
};

const StyledPaper = styled(MUIPaper)(({ theme }) => ({
  padding: theme.spacing(2),
  borderColor: "#F1F2F4",
  ...theme.typography.body2,
  height: "fit-content",
}));

const Paper: React.FC<PaperProps> = ({ children, variant, sx }) => (
  <StyledPaper variant={variant} sx={sx}>
    {children}
  </StyledPaper>
);

export default Paper;
